"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.BaseWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BaseWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficBaseCardStyles__BaseWrapper",
  componentId: "h9sho1-0"
})(["width:", ";height:", ";overflow:hidden;"], function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var height = _ref2.height;
  return height || '100%';
});

exports.BaseWrapper = BaseWrapper;

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficBaseCardStyles__Wrapper",
  componentId: "h9sho1-1"
})(["box-sizing:border-box;height:100%;margin-right:0.2rem;opacity:", ";background:", ";color:", ";border-radius:", ";border-right:", ";border:", ";margin:", ";", " ", " ", ";"], function (_ref3) {
  var searched = _ref3.searched;
  return searched === false ? '0.5' : '1';
}, function (_ref4) {
  var color = _ref4.color;
  return color || '#08C281';
}, function (_ref5) {
  var textColor = _ref5.textColor;
  return textColor || 'white';
}, function (_ref6) {
  var borderRadius = _ref6.borderRadius;
  return borderRadius || '0.2rem';
}, function (_ref7) {
  var borderRight = _ref7.borderRight,
      free = _ref7.free,
      close = _ref7.close;
  return borderRight && !free && !close ? borderRight : 'initial';
}, function (_ref8) {
  var searched = _ref8.searched,
      searchTerm = _ref8.searchTerm;
  return searched && searchTerm ? '4px solid #ffbf00' : '';
}, function (_ref9) {
  var margin = _ref9.margin;
  return margin || 'initial';
}, function (_ref10) {
  var conflict = _ref10.conflict,
      color = _ref10.color;
  return conflict && "\n    background: ".concat(color || '#F12A1C', ";\n  ");
}, function (_ref11) {
  var free = _ref11.free,
      unused = _ref11.unused,
      isOverFree = _ref11.isOverFree;
  return free && "\n      border-radius: 0.2rem;\n      background: ".concat(unused ? 'rgba(60, 100, 138, 0.2)' : '#3C648A', ";\n      margin-right: 0.2rem;\n      border: 0.2rem ").concat(unused ? 'rgba(81, 175, 236, 0.2)' : isOverFree ? 'orange' : '#51AFEC', " solid;\n    ");
}, function (_ref12) {
  var close = _ref12.close;
  return close && "\n    border-radius: 0.2rem;\n    border: none;\n    background: linear-gradient(to top right,\n      #1D2638 0%,\n      #1D2638 calc(50% - 0.15rem),\n      rgba(0,0,0,1) 50%,\n      #1D2638 calc(50% + 0.15rem),\n      #1D2638 100%);\n  ";
});

exports.Wrapper = Wrapper;